<template>
<div class="chapter">
<div class="inner_page">
<h1>The Story-book</h1>
<h1 class="sigil_not_in_toc">Of Science</h1>
<h2 class="sigil_not_in_toc">Jean-Henri Fabre</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?52c6d77e